// extracted by mini-css-extract-plugin
module.exports = {"main":"SubscriptionPlansLayout_main__1oUvj","header":"SubscriptionPlansLayout_header__30JO7"};